import styled, { css } from 'styled-components';
import Select from 'react-select';

import { colours, fonts } from 'themes/default';
const { fontStyleRegular } = fonts;

const StyledSelect = styled(Select)`
  & .react-select__control,
  & .react-select__control:hover,
  & .react-select__control--is-focused {
    border-color: ${(props) => (props.isInvalid ? 'red' : 'grey')};
    border-radius: 0;
    outline: none;
    box-shadow: none;
    height: 24px;
    min-height: 24px;
  }

  & .react-select__indicators {
    padding: 0;
    height: 24px;
    min-height: 24px;
  }

  .react-select__value-container {
    padding: 0 2px;
    height: 24px;
    min-height: 24px;
    font-family: ${fonts.fontFamily};
    color: ${colours.Greyscale.CharcoalGrey};
    font-size: 16px;
  }

  .react-select__input-container {
    margin: 0 2px;
    padding-bottom: 0;
    padding-top: 0;
    font-family: ${fonts.fontFamily};
    color: ${colours.Greyscale.CharcoalGrey};
    font-size: 16px;
  }

  display: inline-block;
  width: 180px;
  box-shadow: none;

  ${(prop) =>
    prop.classes === 'StyledDiallingSelect'
      ? css`
          width: auto;
          border-radius: 5px;

          & .react-select__control {
            border-radius: 5px;
            height: 38px;
            border: 1px solid ${colours.Greyscale.SilverGrey};
          }

          & .react-select__control:hover,
          & .react-select__control--is-focused {
            border-color: ${(props) => (props.isInvalid ? 'red' : 'grey')};
            border-radius: 5px;
            outline: none;
            box-shadow: none;
            height: 38px;
            min-height: 38px;
            cursor: pointer;
          }

          & .react-select__indicators {
            padding: 0;
            height: 38px;
            min-height: 38px;
          }

          & .react-select__value-container {
            padding: 0 2px;
            height: 38px;
            min-height: 38px;
          }

          .react-select__input-container {
            margin: 0 2px;
            padding-bottom: 0;
            padding-top: 0;
          }

          & .react-select__menu {
            margin-top: 18px;
          }
        `
      : ''};

  ${(prop) =>
    prop.classes === 'styled-passenger-form-code-selector'
      ? css`
          border-radius: 5px;

          & .react-select__control {
            height: 30px;
            border: 0.05em solid ${colours.Shades.TintBlue10};
            padding: 2px;
            border-radius: 0.35em;
            background-color: ${colours.Greyscale.White};
            box-sizing: border-box;
          }

          & .react-select__control--is-disabled {
            background-color: ${colours.Greyscale.SilverGrey};
          }

          & .react-select__control:hover {
            border: 0.05em solid ${colours.Shades.TintBlue10};
            outline: none;
            box-shadow: none;
            height: 30px;
            min-height: 30px;
          }

          & .react-select__control--is-focused {
            border-radius: 0.35em;
            outline: none;
            box-shadow: 0 0 0 1px ${colours.Core.CoreNavy};
            height: 30px;
            min-height: 30px;
          }

          & .react-select__single-value {
            ${fontStyleRegular}
          }

          & .react-select__indicators {
            box-shadow: none;
          }

          & .react-select__value-container {
            box-shadow: none;
          }

          & .react-select__input-container {
            box-shadow: none;
          }

          & .react-select__menu {
            box-shadow: none;
          }
        `
      : ''};

  ${(prop) =>
    prop.classes === 'booking-path-passenger-form-code-selector'
      ? css`
          width: 100%;

          & .react-select__control,
          & .react-select__control:hover,
          & .react-select__control--is-focused {
            box-sizing: border-box;
            height: 24px;
            min-height: 24px;
          }

          & .react-select__value-container,
          & .react-select__input-container,
          & .react-select__indicators {
            height: 24px;
            min-height: 24px;
          }
        `
      : ''};
`;

export default StyledSelect;
